import { createContext } from "react";

export const ServiceContext = createContext({})